import React, { useState } from 'react';
import styled from 'styled-components';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import HyperLink from 'components/Core/HyperLink';
import Tooltip from 'components/Core/Tooltip';
import { ArrowRightIcon, ArrowRightHoverIcon } from 'components/Brand/Icons';
import Styles from 'components/Styles';

const CallToActionTextLabel = ({ styles, tooltip, url, handleOnClick, textLabel }) => {
  const [isHovering, setIsHovering] = useState(false);
  const phoneNumUrl = tooltip && url?.startsWith('tel');
  const isRichTextLabel = textLabel?.__typename === 'ContentfulRichText';
  const label = isRichTextLabel ? <ContentfulRichText richText={textLabel} /> : textLabel;

  return (
    <Styles {...styles}>
      {phoneNumUrl && (
        <Tooltip title={tooltip} className="cta-tooltip min-md">
          {label}
        </Tooltip>
      )}
      <StyledHyperLink
        href={url}
        onClick={handleOnClick}
        className={`cta-text-link ${phoneNumUrl ? 'max-md' : ''}`}
        data-testid="call-to-action--text-link"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        {label}
        {isHovering ? <ArrowRightHoverIcon /> : <ArrowRightIcon />}
      </StyledHyperLink>
    </Styles>
  );
};

export default CallToActionTextLabel;

const StyledHyperLink = styled(HyperLink)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 30px;
  position: absolute;
  bottom: 0;

  .rich-text--container {
    width: fit-content;
    position: relative !important;
    padding-right: 5px !important;

    p {
      margin: 0 !important;
      width: fit-content;
    }
  }
`;
